/**
 * Created by dvircohen on 06/12/2016.
 */
(function () {
    'use strict';

    // @ngInject
    function TimezoneServiceCtor(moment, jstz) {
        this.moment = moment;
        this.jstz = jstz;

        this.timezones = ['PDT/PST', 'MDT/MST', 'CDT/CST', 'EDT/EST', 'HST', 'AKDT/AKST', 'AST', 'NST/NDT'];
        var serverTimeZones = ['PDT', 'MDT', 'CDT', 'EDT', 'HST', 'AKDT', 'AST', 'NST'];

        this.serverToClientMap = {};
        this.clientToServerMap = {};

        for (var i = 0; i < this.timezones.length; i++) {
            var clientTimezone = this.timezones[i];
            var serverTimezone = serverTimeZones[i];
            this.serverToClientMap[serverTimezone] = clientTimezone;
            this.clientToServerMap[clientTimezone] = serverTimezone;
        }

        this.hbZoneToMomentZoneNameMap = {
            'PDT': 'America/Los_Angeles',
            'MDT': 'America/Denver',
            'EDT': 'America/New_York',
            'CDT': 'America/Chicago',
            'HST': 'HST',
            'AKDT': 'America/Anchorage',
            'AST': 'America/Puerto_Rico',
            'NST': 'America/St_Johns'
        };

        this.hbZoneNameMapToTimeZone = {
            'America/Los_Angeles': 'PDT/PST',
            'America/Denver': 'MDT/MST',
            'America/New_York': 'EDT/EST',
            'America/Chicago': 'CDT/CST',
            'HST': 'HST',
            'America/Anchorage': 'AKDT/AKST',
            'America/Puerto_Rico': 'AST',
            'America/St_Johns': 'NST/NDT'
        };

        this.DEFAULT_TIMEZONE = this.timezones[0];
    }

    Services.TimezoneService = Class({

        constructor: TimezoneServiceCtor,

        getTimezones: function getTimezones() {
            return angular.copy(this.timezones);
        },

        getMomentTimezone: function getMomentTimezone(timezone) {
            return this.hbZoneToMomentZoneNameMap[timezone || this.clientToServerMap[this.DEFAULT_TIMEZONE]];
        },

        translateFromServer: function translateFromServer(serverTimezone) {
            return this.serverToClientMap[serverTimezone];
        },

        translateToServer: function translateToServer(clientTimezone) {
            return this.clientToServerMap[clientTimezone];
        },

        getTimezoneForCompany: function getTimezoneForCompany(company) {
          if (company.default_timezone !== null) {
              return this.translateFromServer(company.default_timezone);
          }

          return this.DEFAULT_TIMEZONE;
        },

        getDefaultTimezoneIndex: function getDefaultTimezoneIndex() {
            var defaultZone = this.moment().tz(this.jstz.determine().name()).zoneAbbr();

            var index = 0;
            if (defaultZone) {
                for (var i = 0; i < this.timeZones.length; i++) {
                    if (this.timeZones[i].toLowerCase().indexOf(defaultZone.toLowerCase()) > -1) {
                        index = i;
                    }
                }
            }

            return index;
        }
    });
}());
